import * as React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';

import { Table, Select } from 'antd';

import { getLocationQuery, getUrlSearch } from 'shared/utils/url';
import Search from 'shared/components/Search/Search';

import s from './NotificationUsers.pcss';
import Loader from '../../../../shared/components/Loader/Loader';


const userSearchColumns = [{
  title: 'Имя',
  dataIndex: 'fullName',
  width: '25%',
  render: (text, record) => (
    <div className={s.nameContainer}>
      <div className={s.name}>{text}</div>
      {record.groupArray &&
        <div className={s.tagList}>
          {record.groupArray.map(group => (
            <div key={group.id} className={s.tagItem}>{group.name}</div>
          ))}
        </div>
      }
    </div>
  ),
},
{
  title: 'E-mail',
  dataIndex: 'email',
  width: '25%',
},
{
  title: 'Должность',
  dataIndex: 'positionName',
  width: '25%',
  render: text => text || 'Не известно',
},
{
  title: 'Подразделение',
  dataIndex: 'unitId.name',
  width: '25%',
  render: text => text || 'Не известно',
}];

const groupSearchColumns = [{
  title: 'Название группы',
  dataIndex: 'name',
  width: '100%',
  render: text => (
    <div className={s.nameContainer}>
      <div className={s.name}>{text}</div>
    </div>
  ),
}];

const SEARCH_TYPE_BY_USER_NAME = 'users';
const SEARCH_TYPE_BY_GROUP_NAME = 'groups';


@withRouter
export default class NotificationUsers extends React.Component {
  static propTypes = {
    users: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    groups: PropTypes.arrayOf(PropTypes.shape()),
    onSelectUser: PropTypes.func.isRequired,
    selected: PropTypes.arrayOf(PropTypes.string).isRequired,
    loading: PropTypes.bool.isRequired,
    total: PropTypes.number.isRequired,
    location: PropTypes.shape().isRequired,
    history: PropTypes.shape().isRequired,
  };

  static defaultProps = {
    groups: [],
  };


  handleSearch = (filterBy) => {
    const { location } = this.props;
    const query = getLocationQuery(location);
    query.search = filterBy || undefined;
    query.page = undefined;

    this.props.history.push({
      pathname: this.props.location.pathname,
      search: getUrlSearch(query),
    });
  };

  onSearchTypeSelect = (value) => {
    const { location } = this.props;
    const query = getLocationQuery(location);
    query.type = value;

    this.props.history.push({
      pathname: this.props.location.pathname,
      search: getUrlSearch(query),
    });
  };

  cancelSelection = () => this.props.onSelectUser([]);

  changePage = ({ current }) => {
    const { location } = this.props;
    const query = getLocationQuery(location);
    query.page = current > 1 ? current : undefined;

    this.props.history.replace({
      pathname: this.props.location.pathname,
      search: getUrlSearch(query),
    });
  };

  componentDidMount() {
    const { location } = this.props;
    const query = getLocationQuery(location);

    if (!query.type) {
      this.props.history.replace({
        pathname: this.props.location.pathname,
        search: getUrlSearch({ ...query, type: SEARCH_TYPE_BY_USER_NAME }),
      });
    }
  }

  render() {
    const { location, selected, users, groups } = this.props;

    const query = getLocationQuery(location);
    const tableColumns = query.type === SEARCH_TYPE_BY_GROUP_NAME ? groupSearchColumns : userSearchColumns;
    const tableDataSource = query.type === SEARCH_TYPE_BY_GROUP_NAME ? groups : users;

    const rowSelection = {
      selectedRowKeys: selected,
      onChange: this.props.onSelectUser,
    };

    const loading = {
      spinning: this.props.loading,
      indicator: <Loader fullScreen={false} size={20} />,
    };

    return (
      <div className={s.container}>
        <div className={`${s.controls} ${selected.length > 0 ? s.selectedControls : ''}`}>
          <div className={s.selectedCount}>
            {selected.length} значения выбрано
          </div>

          <div className={s.searchContainer}>
            <span>Искать по:</span>

            <Select
              size="small"
              className={s.searchContainer__select}
              value={query.type}
              onChange={this.onSearchTypeSelect}
            >
              <Select.Option value={SEARCH_TYPE_BY_GROUP_NAME}>По группам</Select.Option>
              <Select.Option value={SEARCH_TYPE_BY_USER_NAME}>По пользователям</Select.Option>
            </Select>

            <div className={s['searchContainer__search-wrapper']}>
              <Search onSearch={this.handleSearch} value={query.search} />
            </div>
          </div>

          <div className={s.selectedBtns}>
            <div
              className={s.cancelAccessBtn}
              onClick={this.cancelSelection}
            >
              Отменить
            </div>
          </div>
        </div>

        <div className={s.tableContainer}>
          <Table
            rowKey={r => r.id}
            rowSelection={rowSelection}
            pagination={{ current: parseInt(query.page, 10), pageSize: 10, total: this.props.total }}
            columns={tableColumns}
            onChange={this.changePage}
            loading={loading}
            dataSource={tableDataSource}
            scroll={{ y: 'calc(100vh - 300px)' }}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Root/pages/Notifications/NotificationUsers/NotificationUsers.js